/**
 * Burn rate for Luxury Escapes loyalty points
 * 1 point = $0.004 AUD, or equivalently $1 = 250 points
 */
// [TODO]: Get this from the backend
// https://aussiecommerce.atlassian.net/browse/SHOP-551
export const POINTS_TO_DOLLARS_RATE = 0.004

/**
 * Converts a price in dollars to the equivalent number of loyalty points
 * @param price The price in dollars
 * @returns The equivalent number of points (rounded to nearest whole number)
 */
export function convertPriceToPoints(price: number): number {
  return Math.round(price / POINTS_TO_DOLLARS_RATE)
}

/**
 * Converts loyalty points to the equivalent price in dollars
 * @param points The number of loyalty points
 * @returns The equivalent price in dollars
 */
export function convertPointsToPrice(points: number): number {
  return points * POINTS_TO_DOLLARS_RATE
}

export const MERCHANDISE_ORDER_DISCLAIMER = 'Your account will be credited within 30-40 days.'

export const MERCHANDISE_SHIPPING_DISCLAIMER = 'Some items may be shipped separately or together. Tracking links will appear once available.'
